__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module__Vfa7IW__breadcrumbs",
  "current": "Breadcrumbs-module__Vfa7IW__current",
  "dark": "Breadcrumbs-module__Vfa7IW__dark",
  "item": "Breadcrumbs-module__Vfa7IW__item",
  "link": "Breadcrumbs-module__Vfa7IW__link",
  "list": "Breadcrumbs-module__Vfa7IW__list",
  "separator": "Breadcrumbs-module__Vfa7IW__separator",
});
